import styled from "styled-components";

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background-color: white;
  padding: 30px;
  border-radius: 5px;
  width: 400px;
  text-align: center;
`;

const Message = styled.p`
  font-size: 16px;
  color: #333;
  margin: 20px 0;
`;

const ConfirmButton = styled.button`
  background-color: #2282e9;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
  
  &:hover {
    background-color: #1a76d2;
  }
`;

interface RechargeCompleteModalProps {
  onClose: () => void;
}

export default function RechargeCompleteModal({ onClose }: RechargeCompleteModalProps) {
  return (
    <ModalOverlay>
      <ModalContent>
        <Message>입금이 확인되어 플리머니가 충전되었습니다.</Message>
        <ConfirmButton onClick={onClose}>확인</ConfirmButton>
      </ModalContent>
    </ModalOverlay>
  );
} 